import Repository from './Repository'

export default {
    postFormData (payload) {
        if (payload.formTag) {
            payload.formTag = `/${payload.formTag}`;
        }
        return Repository.post('emails' + payload.formTag, payload.postData);
    }
}